var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fixed"},[_c('h3',[_vm._v("Requesting anonymous session")]),_c('h4',[_vm._v(_vm._s(_vm.result))])])
}
var staticRenderFns = []

export { render, staticRenderFns }